import { Component, OnInit } from "@angular/core";
import { AutenticarService } from "../servicios/autenticar.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-panel",
  templateUrl: "./adminPanel.component.html",
  styleUrls: ["./adminPanel.component.css"],
})
export class AdminPanelComponent implements OnInit {
  tituloOpcion: string = "Selecciona una opción";
  descripcionOpcion: string = "Elige una opción del menú para comenzar.";

  // Estado para submenús
  opcionSeleccionada: string | null = null;
  subOpciones: { titulo: string; accion: string }[] = [];

  constructor(
    private autenticaService: AutenticarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    /*
    if (!this.autenticaService.isAdmin()) {
      this.router.navigate(["/portada"]);
    }
    */
  }

  opcionPiensos() {
    this.tituloOpcion = "Gestión de Piensos";
    this.descripcionOpcion = "Elige una acción sobre los piensos.";
    this.opcionSeleccionada = "piensos";
    this.subOpciones = [
      { titulo: "Listar Piensos", accion: "listar" },
      { titulo: "Añadir Pedido", accion: "anadir" },
    ];
  }

  opcionCorderos() {
    this.tituloOpcion = "Gestión de Corderos";
    this.descripcionOpcion = "Elige una acción sobre los corderos.";
    this.opcionSeleccionada = "corderos";
    this.subOpciones = [
      { titulo: "Listar Corderos", accion: "listar" },
      { titulo: "Añadir Pedido", accion: "anadir" },
    ];
  }

  ejecutarAccion(accion: string) {
    if (this.opcionSeleccionada === "piensos") {
      if (accion === "listar") {
        //console.log("Ir a lista de piensos");
        this.router.navigate(["/adminLisPiensos"]);
      }
      if (accion === "anadir") {
        //console.log("Ir a añadir pedido de piensos");
        this.router.navigate(["/adminPiensosForm"]);
      }
    }

    if (this.opcionSeleccionada === "corderos") {
      if (accion === "listar") {
        //console.log("Ir a lista de corderos");
        this.router.navigate(["/adminLisCorderos"]);
      }
      if (accion === "anadir") {
        //console.log("Ir a añadir pedido de corderos");
        this.router.navigate(["/adminCorderosForm"]);
      }
    }
  }
}
